import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentDownloadPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: DocumentDownloadPayload) =>
    $actions.document.getDocumentDownloadUrl(dispatch, payload),
  );
};
